<template>
  <div
    class="min-h-screen flex items-center justify-center px-4 bg-gradient-to-b from-sky-50 via-white to-sky-100 dark:from-[#020617] dark:via-[#020617] dark:to-[#020617]"
  >
    <div
      class="w-full max-w-md rounded-3xl border border-black/5 dark:border-white/10 bg-white/90 dark:bg-zinc-950/80 shadow-[0_24px_70px_rgba(15,23,42,0.45)] backdrop-blur-xl px-6 py-7 sm:px-8 sm:py-9 text-center space-y-5"
    >
      <div class="inline-flex items-center gap-2 rounded-full bg-sky-50 text-sky-700 px-3 py-1 text-[11px] font-semibold tracking-[0.18em] uppercase dark:bg-sky-500/10 dark:text-sky-200">
        <span class="h-1.5 w-1.5 rounded-full bg-sky-500"></span>
        <span>Billing status</span>
      </div>

      <div class="space-y-2">
        <h1 class="text-xl sm:text-2xl font-semibold tracking-tight text-zinc-950 dark:text-zinc-50">
          Checkout canceled
        </h1>
        <p class="text-sm sm:text-[15px] leading-relaxed text-zinc-600 dark:text-zinc-300">
          Your subscription wasn’t completed. You can start a new checkout whenever you’re ready.
        </p>
      </div>

      <div class="pt-2 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
        <router-link
          to="/pricing"
          class="inline-flex items-center justify-center rounded-full bg-zinc-900 px-5 py-2.5 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(15,23,42,0.6)] transition hover:bg-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-100 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-200 dark:focus-visible:ring-offset-[#020617]"
        >
          Back to pricing
        </router-link>

        <router-link
          to="/dashboard"
          class="inline-flex items-center justify-center rounded-full border border-zinc-300/80 bg-white/70 px-4 py-2 text-xs sm:text-sm font-medium text-zinc-700 transition hover:border-zinc-400 hover:text-zinc-900 dark:border-zinc-700/80 dark:bg-zinc-900/70 dark:text-zinc-200 dark:hover:border-zinc-500"
        >
          Go to dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
 